<div class="galaxy-wrapper">
  <button class="reset-btn" (click)="resetView()">Reset View</button>
  <div #graphContainer class="graph-container"></div>

  <div class="project-info-box" *ngIf="selectedNode">
    <button class="close-button" (click)="closeInfoBox()">✖️</button>
    <h3>{{ selectedNode.name }}</h3>
    <div class="scrollable-description">
      <div *ngIf="selectedNode.type !== 'planet'">
        <p><strong>Number of projects:</strong> {{ selectedNode.data.planetCount || 'N/A' }}</p>
      </div>
      <div *ngIf="selectedNode.type === 'planet'">
        <p><strong>Team:</strong> {{ selectedNode.data.team || 'N/A' }}</p>
        <p><strong>Tech Maturity:</strong> {{ selectedNode.data.techMaturity || 'N/A' }}</p>
        <p><strong>Project Status:</strong> {{ selectedNode.data.projectStatus || 'N/A' }}</p>
        <p>
          <a [href]="'https://slb001.sharepoint.com/sites/STICRadars/' + selectedNode.data.path" target="_blank"
            ><strong>Sharepoint Site</strong></a
          >
        </p>
      </div>
    </div>
  </div>
</div>
